import { CreateUserAPIResponse, CreateUserResultTypes, SubmitValues } from '../types';
import { getCountryPhoneCodeFromHostName } from '../helpers';

export const fetchPendingUserResults = async ({ mobileNumber, email, partnerNumber }: SubmitValues) => {
  const requestBody: SubmitValues = {
    mobileNumber: getCountryPhoneCodeFromHostName() + mobileNumber,
    email,
    partnerNumber,
  };

  /* ISSUE ref AKW-2263 (Dirty hack - Should be solved by properly set enviroment variables)
  IAP blocks http requests based on IP, and this change helps webedge to detect client IP instead of the webserver IP.
  */
  let url = '/iap/api/user';
  if (window.altibox.commons.isProduction()) {
    url = 'https://iap.services.altibox.net/api/user';
  } else if (window.altibox.commons.isAT()) {
    url = 'https://iap-at.services.altibox.net/api/user';
  }
  // ENDS resolution to ISSUE AKW-2263

  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (response.status === 204) {
        return { result: CreateUserResultTypes.USER_NOT_FOUND };
      } else {
        return response.json();
      }
    })
    .then((response: CreateUserAPIResponse) => {
      return response.result as CreateUserResultTypes;
    });
};
